<template>
    <div v-if="meeting">
        <vs-alert :active="meeting.denied" class="mt-5 mb-6" icon-pack="feather" icon="icon-alert-circle" color="danger">
            {{$t("DeniedReason")}} {{this.meeting.denial_reason}}
        </vs-alert>

        <vs-alert :active="meeting.status === 4" class="mt-5 mb-6" icon-pack="feather" icon="icon-alert-circle" color="success">
            {{$t("MeetingConfirmed")}}: {{this.meeting.approval_notes}}
        </vs-alert>

        <div class="vx-row">
            <div class="vx-col lg:w-1/3 w-full">
                <vx-card class="mb-6" :title="meeting.title + ' - ' + moment(meeting.start_time).format('DD/MM/YYYY HH:mm')">
                    <h6 class="mb-6">{{$t("Client")}}: {{$store.getters.companyClients[meeting.client_company_id].name}}</h6>

                    <vs-button v-if="meeting.status === 0" type="border" class="mr-3 mb-3" color="success" @click="startMeeting">{{$t("StartMeeting")}}</vs-button>
                    <vs-button v-if="meeting.status === 1" type="border" class="mr-3 mb-3" color="danger" @click="endMeeting">{{$t("EndMeeting")}}</vs-button>
                    <vs-button v-if="meeting.status === 2 || meeting.status === 3" id="sendToConfirmButton" type="border" class="mr-3 mb-3 vs-con-loading__container" @click="sendToConfirmPrompt = true">{{$t("SendToConfirm")}}</vs-button>
                    <vs-button v-if="meeting.status > 0 && meeting.status < 4" id="previewButton" type="border" color="warning" @click="getPDFPreview" class="mt-3 mb-3 vs-con-loading__container">{{ $t("Preview") }}</vs-button>
                    <vs-button v-if="meeting.status === 4" type="border" color="warning" @click="openApprovalPDF" class="mt-3">{{ $t("OpenMeetingPrintout") }}</vs-button>

                </vx-card>
            </div>
            <div class="vx-col lg:w-1/3 w-full">
                <vx-card class="mb-6" :title="$t('Users')">
                    <vs-button v-if="meeting.status < 3 && ($store.getters.userData.id === meeting.company_user_id || $checkPermission(2003))" type="border" class="mr-3 mb-4" color="success" @click="activeAddUserPrompt = true">{{$t("Add")}}</vs-button>
                    <vs-table :data="users">
                        <template slot="thead">
                            <vs-th>{{$t("Name")}}</vs-th>
                        </template>

                        <template slot-scope="{data}">
                            <vs-tr>
                                <vs-td :data="$store.getters.companyUsers[meeting.company_user_id].name">
                                    {{$store.getters.companyUsers[meeting.company_user_id].name}}
                                </vs-td>
                            </vs-tr>
                            <vs-tr :key="indextr" v-for="(tr, indextr) in data" >
                                <vs-td :data="$store.getters.companyUsers[tr].name">
                                    <vs-button v-if="meeting.status < 3 && ($store.getters.userData.id === meeting.company_user_id || $checkPermission(2003))" style="float:right;" type="border" color="danger" icon-pack="feather" icon="icon-trash-2" size="small" class="mr-4" @click="removeUser(tr)"></vs-button>
                                    <p class="mt-2">
                                        {{$store.getters.companyUsers[tr].name}}
                                    </p>
                                </vs-td>
                            </vs-tr>
                        </template>
                    </vs-table>
                </vx-card>
            </div>
            <div class="vx-col lg:w-1/3 w-full">
                <vx-card class="mb-6" :title="$t('Contacts')">
                    <vs-button v-if="meeting.status < 3 && ($store.getters.userData.id === meeting.company_user_id || $checkPermission(2003))" type="border" class="mr-3 mb-4" color="success" @click="activeAddContactPrompt = true">{{$t("Add")}}</vs-button>
                    <vs-table :data="contacts">
                        <template slot="thead">
                            <vs-th>{{$t("Name")}}</vs-th>
                            <vs-th>{{$t("Mail")}}</vs-th>
                        </template>

                        <template slot-scope="{data}">
                            <vs-tr :key="indextr" v-for="(tr, indextr) in data" >
                                <vs-td :data="tr.name">
                                    <vs-button v-if="meeting.status < 3 && ($store.getters.userData.id === meeting.company_user_id || $checkPermission(2003))" style="float:left;" type="border" color="danger" icon-pack="feather" icon="icon-trash-2" size="small" class="mr-4" @click="removeContact(tr.id)"></vs-button>
                                    <p class="mt-2">
                                        {{tr.name}}
                                    </p>
                                </vs-td>

                                <vs-td :data="tr.email">
                                    <p class="mt-2">
                                        {{tr.email}}
                                    </p>
                                </vs-td>
                            </vs-tr>
                        </template>
                    </vs-table>
                </vx-card>
            </div>
        </div>

        <div v-if="loadPoints">
            <vx-card :title="'' + point.point_num + '.'" v-for="(point, index) in points" :key="point.id" class="mb-3">
                <vs-alert :active="JSON.stringify(point) !== JSON.stringify(pointsCopy[index])" class="mb-3" color="warning"> {{$t("UnsavedChanges")}}! </vs-alert>
                <div class="vx-row">
                    <div class="vx-col">
                        <vs-button v-if="JSON.stringify(point) !== JSON.stringify(pointsCopy[index]) && meeting.status < 3" type="border" color="success" class="mb-3 mr-3" @click="savePointData(index)">{{$t("Save")}}</vs-button>
                        <vs-button v-if="point.task_id === 0 && point.offer_id === 0 && meeting.status > 0 && meeting.status < 3" type="border" class="mb-3 mr-3" @click="openTaskAdding(point.id, point.text)">{{$t("AddTask")}}</vs-button>
                        <vs-button v-if="point.task_id !== 0" type="border" class="mb-3 mr-3" @click="$router.push('/task/' + point.task_id)">{{$t("OpenTask")}}</vs-button>
                        <vs-button v-if="point.task_id === 0 && point.offer_id === 0 && meeting.status > 0 && meeting.status < 3" type="border" class="mb-3 mr-3" @click="openOfferAdding(point.id, point.text)">{{$t("AddOffer")}}</vs-button>
                        <vs-button v-if="point.offer_id !== 0" type="border" class="mb-3 mr-3" @click="$router.push('/offer/' + point.offer_id)">{{$t("OpenOffer")}}</vs-button>
                        <vs-button v-if="meeting.status < 3" type="border" class="mb-3 mr-3" color="danger" @click="removePoint(point.id)">{{$t("RemovePoint")}}</vs-button>
                    </div>
                </div>
                <div class="vx-row" >
                    <div class="vx-col w-full">
                        <vs-textarea v-bind:style="{height: $calculateTextArea(point.text)}"  v-model="point.text" v-if="!($store.getters.userData.id !== meeting.company_user_id || !(meeting.status < 3))" />
                        <p style="white-space: pre-wrap" v-else>{{point.text}}</p>
                    </div>

                </div>
            </vx-card>
        </div>

        <vs-button v-if="meeting.status < 3" type="border" class="mr-3 mb-3 mt-3" @click="addPoint">{{$t("AddMeetingPoint")}}</vs-button>


        <vs-popup :title="$t('Add')" :active.sync="activeNewTaskPrompt" style="z-index: 54000;">
            <vx-card>
                <vs-row vs-w="12" vs-justify="space-around">
                    <vs-col vs-w="6" vs-sm="12">
                        <p>{{$t("TaskTitle")}}</p>
                        <vs-input v-model="taskAddTitle"/>
                        <p class="mt-6">{{$t("BranchOffice")}}</p>
                        <vs-select autocomplete class="selectExample" v-model="taskAddBranchOffice">
                            <vs-select-item :key="index" :value="item.id" :text="item.title" v-for="(item,index) in branchOffices" />
                        </vs-select>
                        <p class="mt-6">{{$t("Priority")}}</p>
                        <vs-select autocomplete class="selectExample" v-model="taskAddPriority">
                            <vs-select-item :key="index" :value="item.id" :text="item.name" v-for="(item,index) in [{id:1, name:1}, {id:2, name:2}, {id:3, name:3}, {id:4, name:4}, {id:5, name:5}]" />
                        </vs-select>
                    </vs-col>
                    <vs-col vs-w="6" vs-sm="12">
                        <vs-checkbox class="mt-6 mb-6" v-model="assignToYourself">{{$t("TakeTask")}}</vs-checkbox>
                        <p class="mt-6">{{$t("Tags")}}</p>
                        <v-select class="selectStyle" multiple :options="selectableTags" label="name" v-model="taskAddTags">
                            <template slot="option" slot-scope="option">
                                <div style="display: flex">
                                    <vs-chip :color="option.color" style="margin: auto" class="mt-1">
                                        <p v-bind:style="{color: option.text_color}"><b>{{ option.name}}</b></p>
                                    </vs-chip>
                                </div>
                            </template>
                        </v-select>
                        <p class="mt-6">{{$t("Deadline")}}</p>
                        <flat-pickr :config="configDateTimePicker" v-model="taskAddDeadline"/>
                    </vs-col>
                </vs-row>

                <p class="mt-6">{{$t("Description")}}</p>
                <vs-textarea v-model="taskAddDescription" style="min-height: 150px" class="w-full mb-6" v-bind:style="{height: $calculateTextArea(taskAddDescription)}"/>

                <vs-divider/>

                <vs-button id="newTaskButton" color="success" class="mt-6; mr-1" @click="addTask">{{$t("Add")}}</vs-button>

            </vx-card>

        </vs-popup>

        <vs-popup :title="$t('Add')" :active.sync="addOfferPrompt">
            <div>
                <p class="mt-6">{{$t("Name")}}</p>
                <vs-input v-model="addOfferName" style="width: 100%"></vs-input>
                <vs-divider/>
                <vs-button color="success" type="border" class="mt-6; mr-1" @click="addOffer">{{$t("Add")}}</vs-button>
            </div>
        </vs-popup>

        <vs-popup :title="$t('Add')" :active.sync="activeAddUserPrompt" style="z-index: 54000">
            <div>
                <vs-select autocomplete class="selectExample" v-model="selectedUserToAdd">
                    <vs-select-item :key="index" :value="item.id" :text="item.name" v-for="(item,index) in usersToAdd" />
                </vs-select>
                <vs-divider/>
                <vs-button color="success" type="border" class="mt-6; mr-1" @click="addUser">{{$t("Add")}}</vs-button>
            </div>
        </vs-popup>

        <vs-popup :title="$t('Add')" :active.sync="activeAddContactPrompt" style="z-index: 54000">
            <div>
                <p class="mt-6">{{$t("Name")}}</p>
                <vs-input v-model="addContactName" style="width: 100%"></vs-input>
                <p class="mt-6">{{$t("Email")}}</p>
                <vs-input v-model="addContactMail" style="width: 100%"></vs-input>
                <vs-divider/>
                <vs-button color="success" type="border" class="mt-6; mr-1" @click="addContact">{{$t("Add")}}</vs-button>
            </div>
        </vs-popup>

        <vs-popup :title="$t('SendToConfirm')" :active.sync="sendToConfirmPrompt" style="z-index: 54000">
            <div>
                <vs-select autocomplete class="selectExample" v-model="selectedContact">
                    <vs-select-item :key="index" :value="item.id" :text="item.name" v-for="(item,index) in contacts" />
                </vs-select>
                <vs-divider/>
                <vs-button :disabled="this.selectedContact.length === 0" color="success" type="border" class="mt-6; mr-1" @click="sendToConfirm">{{$t("SendToConfirm")}}</vs-button>
            </div>
        </vs-popup>

    </div>
</template>
<script>

    import 'quill/dist/quill.core.css'
    import 'quill/dist/quill.snow.css'
    import 'quill/dist/quill.bubble.css'

    import { quillEditor } from 'vue-quill-editor'

    import flatPickr from 'vue-flatpickr-component';
    import 'flatpickr/dist/flatpickr.css';
    import vSelect from "vue-select";

    export default {
        components: {
            quillEditor,
            flatPickr,
            'v-select': vSelect,
        },
        data(){
            return {

                points: [],
                pointsCopy: [],
                meeting: null,

                editorOption: null,

                loadPoints: false,

                branchOffices: [],
                clientData: null,

                activeNewTaskPrompt: false,
                selectedPointId: 0,
                taskAddTitle: '',
                taskAddBranchOffice: '',
                taskAddPriority: '',
                taskAddDeadline: null,
                taskAddDescription: '',
                taskAddTags: [],
                assignToYourself: false,

                addOfferPrompt: false,
                addOfferName: '',

                configDateTimePicker: {
                    enableTime: true,
                    dateFormat: 'Y-m-d H:i',
                    locale: {
                        firstDayOfWeek: 1
                    }
                },

                users: [],
                activeAddUserPrompt: false,
                selectedUserToAdd: 0,

                contacts: [],
                activeAddContactPrompt: false,
                addContactName: '',
                addContactMail: '',

                selectedContact: '',
                sendToConfirmPrompt: false,

            }
        },
        methods: {
            openTaskAdding(pointId, text){
                this.saveAll();
                let splitted = text.split(/\r\n|\r|\n/);
                this.taskAddTitle = splitted[0];
                this.taskAddDescription = '';
                for(let x = 1; x < splitted.length; x++){
                    if(splitted[x].startsWith("---")) break;
                    if(x !== 1) this.taskAddDescription += "\r\n";
                    this.taskAddDescription += splitted[x];
                }

                this.selectedPointId = pointId;
                this.activeNewTaskPrompt = true;
            },
            openOfferAdding(pointId, text){
                this.saveAll();
                this.addOfferName = text.split(/\r\n|\r|\n/)[0];
                this.selectedPointId = pointId;
                this.addOfferPrompt = true;
            },
            updateMeeting(){
                const thisIns = this;
                this.$http.get('/api/v1/meeting/' + this.$route.params.id)
                    .then(function (response) {
                        thisIns.meeting = response.data;
                        if(thisIns.meeting.status < 3){
                            thisIns.editorOption = {}
                        }else{
                            thisIns.editorOption = {theme: 'bubble'}
                        }

                        thisIns.updatePoints();
                        thisIns.updateClient();
                        thisIns.updateUsers();
                        thisIns.updateContacts();

                    })
                    .catch(function (error) {
                        thisIns.$vs.notify({
                            title:'Error',
                            text: error,
                            color:'danger',
                            iconPack: 'feather',
                            icon:'icon-alert-circle'})
                    });
            },
            updatePoints(){
                const thisIns = this;
                this.$http.get('/api/v1/meeting/' + this.$route.params.id + '/point')
                    .then(function (response) {
                        thisIns.points = response.data;
                        thisIns.pointsCopy = JSON.parse(JSON.stringify(response.data));
                        thisIns.loadPoints = true;
                    })
                    .catch(function (error) {
                        thisIns.$vs.notify({
                            title:'Error',
                            text: error,
                            color:'danger',
                            iconPack: 'feather',
                            icon:'icon-alert-circle'})
                    });
            },
            updateContacts(){
                const thisIns = this;
                this.$http.get('/api/v1/meeting/' + this.$route.params.id + '/contact')
                    .then(function (response) {
                        thisIns.contacts = response.data;
                    })
                    .catch(function (error) {
                        thisIns.$vs.notify({
                            title:'Error',
                            text: error,
                            color:'danger',
                            iconPack: 'feather',
                            icon:'icon-alert-circle'})
                    });
            },
            updateUsers(){
                const thisIns = this;
                this.$http.get('/api/v1/meeting/' + this.$route.params.id + '/user')
                    .then(function (response) {
                        thisIns.users = response.data;
                    })
                    .catch(function (error) {
                        thisIns.$vs.notify({
                            title:'Error',
                            text: error,
                            color:'danger',
                            iconPack: 'feather',
                            icon:'icon-alert-circle'})
                    });
            },
            updatePointById(index){
                const thisIns = this;
                this.$http.get('/api/v1/meeting/' + this.$route.params.id + '/point/' + this.points[index].id)
                    .then(function (response) {
                        thisIns.pointsCopy[index].text = response.data.text;
                    })
                    .catch(function (error) {
                        thisIns.$vs.notify({
                            title:'Error',
                            text: error,
                            color:'danger',
                            iconPack: 'feather',
                            icon:'icon-alert-circle'})
                    });
            },
            addPoint(){
                const thisIns = this;
                this.saveAll();
                this.$http.post('/api/v1/meeting/' + this.$route.params.id + '/point')
                    .then(function () {
                        thisIns.updatePoints();
                    })
                    .catch(function (error) {
                        thisIns.$vs.notify({
                            title:'Error',
                            text: error,
                            color:'danger',
                            iconPack: 'feather',
                            icon:'icon-alert-circle'})
                    });
            },
            removePoint(id){
                const thisIns = this;
                for(let x = 0; x < this.points.length; x++){
                    if(this.points[x].text !== this.pointsCopy[x].text) {
                        thisIns.$vs.notify({
                            title:'Error',
                            text: "Save all points before removing",
                            color:'danger',
                            iconPack: 'feather',
                            icon:'icon-alert-circle'});
                        return
                    }
                }
                this.$http.delete('/api/v1/meeting/' + this.$route.params.id + '/point/' + id)
                    .then(function () {
                        thisIns.updatePoints();
                    })
                    .catch(function (error) {
                        thisIns.$vs.notify({
                            title:'Error',
                            text: error,
                            color:'danger',
                            iconPack: 'feather',
                            icon:'icon-alert-circle'})
                    });
            },
            startMeeting(){
                const thisIns = this;
                this.$http.put('/api/v1/meeting/' + this.$route.params.id + '/start')
                    .then(function () {
                        thisIns.loadPoints = false;
                        thisIns.updateMeeting();

                    })
                    .catch(function (error) {
                        thisIns.$vs.notify({
                            title:'Error',
                            text: error,
                            color:'danger',
                            iconPack: 'feather',
                            icon:'icon-alert-circle'})
                    });
            },
            endMeeting(){
                const thisIns = this;
                this.$http.put('/api/v1/meeting/' + this.$route.params.id + '/stop')
                    .then(function () {
                        thisIns.updateMeeting();
                    })
                    .catch(function (error) {
                        thisIns.$vs.notify({
                            title:'Error',
                            text: error,
                            color:'danger',
                            iconPack: 'feather',
                            icon:'icon-alert-circle'})
                    });
            },
            sendToConfirm(){
                const thisIns = this;
                this.sendToConfirmPrompt = false;
                this.$vs.loading({
                    background: "primary",
                    color: "fff",
                    container: "#sendToConfirmButton",
                    scale: 0.45
                });
                this.$http.put('/api/v1/meeting/' + this.$route.params.id + '/finish/' + this.selectedContact)
                    .then(function () {
                        thisIns.updateMeeting();
                        thisIns.$vs.loading.close("#sendToConfirmButton > .con-vs-loading");
                    })
                    .catch(function (error) {
                        thisIns.$vs.loading.close("#sendToConfirmButton > .con-vs-loading");
                        thisIns.$vs.notify({
                            title:'Error',
                            text: error,
                            color:'danger',
                            iconPack: 'feather',
                            icon:'icon-alert-circle'})
                    });
            },
            savePointData(index){
                const thisIns = this;
                this.$http.put('/api/v1/meeting/' + this.$route.params.id + '/point/' + this.points[index].id, {
                    text: this.points[index].text
                })
                    .then(function () {
                        thisIns.updatePointById(index);
                    })
                    .catch(function (error) {
                        thisIns.$vs.notify({
                            title:'Error',
                            text: error,
                            color:'danger',
                            iconPack: 'feather',
                            icon:'icon-alert-circle'})
                    });
            },
            saveAll(){
                for(let x = 0; x < this.points.length; x++){
                    this.savePointData(x);
                }
            },
            updateClient(){
                const thisIns = this;

                this.$http.get('/api/v1/client/' + this.meeting.client_company_id)
                    .then(function (response) {
                        thisIns.clientData = response.data;
                    })
                    .catch(function (error) {
                        thisIns.$vs.notify({
                            title:'Error',
                            text: error,
                            color:'danger',
                            iconPack: 'feather',
                            icon:'icon-alert-circle'})
                    });

                this.$http.get('/api/v1/client/' + this.meeting.client_company_id + "/branch_offices")
                    .then(function (response) {
                        thisIns.branchOffices = response.data;
                        if(thisIns.branchOffices.length > 0){
                            thisIns.taskAddBranchOffice = thisIns.branchOffices[0].id
                        }
                    })
                    .catch(function (error) {
                        thisIns.$vs.notify({
                            title:'Error',
                            text: error,
                            color:'danger',
                            iconPack: 'feather',
                            icon:'icon-alert-circle'})
                    });
            },
            addTask() {

                let companyUser = 0;
                if(this.assignToYourself) {
                    companyUser = this.$store.state.userData.id;
                }

                this.$vs.loading({
                    background: "primary",
                    color: "fff",
                    container: "#newTaskButton",
                    scale: 0.45
                });

                const thisIns = this;
                this.$http.post('/api/v1/meeting/' + this.$route.params.id + '/point/' + this.selectedPointId + "/task", {
                    title: thisIns.taskAddTitle,
                    description: thisIns.taskAddDescription,
                    deadline: thisIns.moment(thisIns.taskAddDeadline).format(),
                    priority: thisIns.taskAddPriority,
                    client_company_id: thisIns.meeting.client_company_id,
                    branch_office_id: Number(thisIns.taskAddBranchOffice),
                    company_user_id: Number(companyUser),
                    tags: thisIns.taskAddTags,
                }).then(function () {
                    thisIns.updateMeeting();

                    thisIns.$vs.loading.close("#newTaskButton > .con-vs-loading");
                    thisIns.activeNewTaskPrompt = false;
                    thisIns.assignToYourself = false;
                    thisIns.taskAddTitle = "";
                    thisIns.taskAddDescription = "";
                }).catch(function (error) {

                    thisIns.$vs.loading.close("#newTaskButton > .con-vs-loading");
                    thisIns.newTaskButtonDisabled = false;
                    thisIns.activeNewTaskPrompt = false;

                    thisIns.$vs.notify({
                        title:'Error',
                        text: error.response.data,
                        color:'danger',
                        iconPack: 'feather',
                        icon:'icon-alert-circle'})
                });
            },
            addOffer() {
                const thisIns = this;
                this.$http.post('/api/v1/meeting/' + this.$route.params.id + '/point/' + this.selectedPointId + "/offer", {
                    name: this.addOfferName,
                })
                    .then(function () {
                        thisIns.addOfferPrompt = false;
                        thisIns.updateMeeting();
                    })
                    .catch(function (error) {
                        thisIns.$vs.notify({
                            title:'Error',
                            text: error,
                            color:'danger',
                            iconPack: 'feather',
                            icon:'icon-alert-circle'})
                    });
            },
            addUser(){
                const thisIns = this;
                this.$http.put('/api/v1/meeting/' + this.$route.params.id + '/user/' + this.selectedUserToAdd)
                    .then(function () {
                        thisIns.updateUsers();
                        thisIns.activeAddUserPrompt = false;
                    })
                    .catch(function (error) {
                        thisIns.$vs.notify({
                            title:'Error',
                            text: error,
                            color:'danger',
                            iconPack: 'feather',
                            icon:'icon-alert-circle'})
                    });
            },
            removeUser(id){
                const thisIns = this;
                this.$http.delete('/api/v1/meeting/' + this.$route.params.id + '/user/' + id)
                    .then(function () {
                        thisIns.updateUsers();
                    })
                    .catch(function (error) {
                        thisIns.$vs.notify({
                            title:'Error',
                            text: error,
                            color:'danger',
                            iconPack: 'feather',
                            icon:'icon-alert-circle'})
                    });
            },
            addContact(){
                const thisIns = this;
                this.$http.post('/api/v1/meeting/' + this.$route.params.id + '/contact/', {
                    name: this.addContactName,
                    email: this.addContactMail
                })
                    .then(function () {
                        thisIns.updateContacts();
                        thisIns.activeAddContactPrompt = false;
                    })
                    .catch(function (error) {
                        thisIns.$vs.notify({
                            title:'Error',
                            text: error,
                            color:'danger',
                            iconPack: 'feather',
                            icon:'icon-alert-circle'})
                    });
            },
            removeContact(id){
                const thisIns = this;
                this.$http.delete('/api/v1/meeting/' + this.$route.params.id + '/contact/' + id)
                    .then(function () {
                        thisIns.updateContacts();
                    })
                    .catch(function (error) {
                        thisIns.$vs.notify({
                            title:'Error',
                            text: error,
                            color:'danger',
                            iconPack: 'feather',
                            icon:'icon-alert-circle'})
                    });
            },
            getPDFPreview(){
                this.$vs.loading({
                    background: "primary",
                    color: "fff",
                    container: "#previewButton",
                    scale: 0.45
                });
                const thisIns = this;
                this.$http.get('/api/v1/meeting/' + this.$route.params.id + '/pdf/preview')
                    .then(function (response) {
                        thisIns.$vs.loading.close("#previewButton > .con-vs-loading");
                        if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent)
                            || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0,4))) {
                            window.location.href = "/pdf/meeting/" + response.data;
                        }else{
                            window.open("/pdf/meeting/" + response.data, "_blank");
                        }
                    })
                    .catch(function (error) {
                        thisIns.$vs.loading.close("#previewButton > .con-vs-loading");
                        thisIns.$vs.notify({
                            title:'Error',
                            position:'top-right',
                            text: error,
                            color:'danger',
                            iconPack: 'feather',
                            icon:'icon-alert-circle'})
                    });
            },
            openApprovalPDF(){
                if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent)
                    || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0,4))) {
                    window.location.href = "/pdf/meeting/" + this.meeting.pdf_id;
                }else{
                    window.open("/pdf/meeting/" + this.meeting.pdf_id, "_blank");
                }
            }
        },
        computed: {
            selectableTags() {

                let tags = [];

                for (let key in this.$store.state.tags) {
                    if (this.$store.state.tags.hasOwnProperty(key)){
                        if(this.$store.state.tags[key].global){
                            tags.push(this.$store.state.tags[key])
                        }
                    }
                }

                if(this.clientData){

                    for(let x = 0; x < this.clientData.tags.length; x++) {
                        if(!tags.includes(this.clientData.tags[x])){
                            tags.push(this.clientData.tags[x]);
                        }
                    }
                }

                return tags;

            },
            usersToAdd: function () {
                if(!this.meeting) return;
                let list = [];
                for (let key in this.$store.getters.companyUsers) {
                    if (!this.$store.getters.companyUsers.hasOwnProperty(key)) continue;
                    if(!this.users.includes(this.$store.getters.companyUsers[key].id) && this.$store.getters.companyUsers[key].id !== this.meeting.company_user_id){
                        list.push(this.$store.getters.companyUsers[key])
                    }
                }

                return list;
            }
        },
        created() {
            this.updateMeeting();
        }

    }

</script>

<style>

</style>
